import styled from 'styled-components'

export const StyledContainer = styled.div`
	padding: 0 229px;
	max-width: 1440px;
	margin: 0 auto;
	box-sizing: border-box;
	margin-top: 60px;
	@media (max-width: 1200px) {
		padding: 0 22px;
	}
	@media (max-width: 768px) {
		margin-top: 60px;
	}
`

export const StyledTitleContainer = styled.div`
	display: grid;
	justify-items: center;
	grid-row-gap: 23px;
`

export const StyledMainContainer = styled.div`
	margin-top: 88px;
	overflow: hidden;
	.slick-slide {
		outline: none !important;
		display: flex !important;
	}
	.slick-track {
		display: flex !important;
		align-items: center;
	}
`

export const StyledInnerContainer = styled.div`
	width: max-content;
	position: relative;
	top: 0;
	transition: all ease 5s;
`

// export const StyledImageContainer = styled.div`
//   display: grid;
//   align-items: center;
//   justify-items: center;
//   position: relative;
//   min-width: 256px !important;
//   height: 61px;
//   img {
//     position: absolute;
//     width: 100%;
//     height: 100%;
//   }
// `;

export const StyledArrowButton = styled.div`
	cursor: pointer;
	background: none;
`

export const StyledLeftArrowBtn = styled(StyledArrowButton)`
	margin-right: 56px;
`
export const StyledRightArrowBtn = styled(StyledArrowButton)`
	margin-left: 56px;
`

export const StyledImageContainer = styled.div`
	img {
		height: 61px;
	}
`
